import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalFileSection6 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const section6 = this.props.form.Section6;

        return (
            <div className="section">
                <div className="row row-form">
                    {this.renderHeader(
                        "FamilyHistoryLabel",
                        6
                    )}
                    <div className="col-md-12">
                        {this.renderNoYesTitleSection5To9()}
                    </div>
                    {this.renderRadioButtonsWithTextBox({
                        value: section6.AnestheticComplications,
                        id: "FamilyHistory_AnestheticComplications",
                        label: "ObstetricalFile_AnestheticComplicationsLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section6.AnestheticComplications.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section6.AnestheticComplications.setDescription(value)),
                        maxLength: this.page1FieldLimits.FamilyHistory_AnestheticComplicationsDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section6.Hypertension,
                        id: "FamilyHistory_Hypertension",
                        label: "HypertensionLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section6.Hypertension.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section6.Hypertension.setDescription(value)),
                        maxLength: this.page1FieldLimits.FamilyHistory_HypertensionDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section6.Thromboembolic,
                        id: "FamilyHistory_Thromboembolic",
                        label: "ThromboembolicLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section6.Thromboembolic.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section6.Thromboembolic.setDescription(value)),
                        maxLength: this.page1FieldLimits.FamilyHistory_ThromboembolicDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section6.Diabetes,
                        id: "FamilyHistory_Diabetes",
                        label: "DiabetesLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section6.Diabetes.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section6.Diabetes.setDescription(value)),
                        maxLength: this.page1FieldLimits.FamilyHistory_DiabetesDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section6.MentalHealth,
                        id: "FamilyHistory_MentalHealth",
                        label: "ObstetricalFile_MentalHealthLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section6.MentalHealth.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section6.MentalHealth.setDescription(value)),
                        maxLength: this.page1FieldLimits.FamilyHistory_MentalHealthDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section6.SubstanceUseDisorder,
                        id: "FamilyHistory_SubstanceUseDisorder",
                        label: "ObstetricalFile_SubstanceUseDisorder",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section6.SubstanceUseDisorder.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section6.SubstanceUseDisorder.setDescription(value)),
                        maxLength: this.page1FieldLimits.FamilyHistory_SubstanceUseDisorderDescription.MaxChars
                    })}
                    <div className="col-md-12 padding-xs-top">
                        <div className="flex-display">
                            {this.renderBooleanRadioButtonsBeforeTextbox({
                                value: section6.InheritedConditionsOrDefects,
                                id: "ObstetricalFile_InheritedConditionsDefects",
                                onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section6.InheritedConditionsOrDefects.Value = value),
                                onChangeDescription: value => this.props.mutateModelState(s => s.Section6.InheritedConditionsOrDefects.setDescription(value)),
                                radioOuterWrapperClassName: "padding-xs-top",
                                radioWrapperClassName: "align-items-start",
                                radioClassName: "flex-display-inline"
                            })}
                            <label className="margin-xs-left">{this.getString("ObstetricalFile_InheritedConditionsDefectsLabel")}</label>
                        </div>
                        {this.renderInlineTextbox({
                            label: "lblMother",
                            value: section6.Mother,
                            onChange: value => this.props.mutateModelState(s => {
                                s.Section6.Mother = value;
                                !IsNullOrWhiteSpace(value) && (s.Section6.InheritedConditionsOrDefects.Value ??= true);
                            }),
                            className: "sub-field",
                            labelClassName: "normal-text",
                            maxLength: this.page1FieldLimits.FamilyHistory_InheritedConditionsOrDefects_MotherDescription.MaxChars
                        })}
                        {this.renderInlineTextbox({
                            label: "ObstetricalFile_BiologicalFatherDonorLabel",
                            value: section6.BiologicalFatherOrDonor,
                            onChange: value => this.props.mutateModelState(s => {
                                s.Section6.BiologicalFatherOrDonor = value;
                                !IsNullOrWhiteSpace(value) && (s.Section6.InheritedConditionsOrDefects.Value ??= true);
                            }),
                            className: "sub-field",
                            labelClassName: "normal-text",
                            maxLength: this.page1FieldLimits.FamilyHistory_InheritedConditionsOrDefects_BiologicalFatherDescription.MaxChars
                        })}
                    </div>
                    {this.renderRadioButtonsWithTextBox({
                        value: section6.Other,
                        id: "FamilyHistory_HasOther",
                        label: "OtherLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section6.Other.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section6.Other.setDescription(value)),
                        maxLength: this.page1FieldLimits.FamilyHistory_OtherDescription.MaxChars
                    })}
                    {this.renderAllEmptyFieldAsNoLink(
                        () => this.props.mutateModelStateWithFormUpdate(s => s.Section6.setEmptyFieldsAsNo())
                    )}
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalFileSection6 };
